/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Check calendar component
 * @author Maarten Lensink

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sym-icon-refresh[_ngcontent-%COMP%]{opacity:.25}.sym-icon-check[_ngcontent-%COMP%]{color:#6bdea1}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:0}"];
export { styles as styles };
